import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// VAPID key for web push notifications
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// Initialize Firebase only if config is available
let app = null;
let auth = null;
let googleProvider = null;
let facebookProvider = null;

if (firebaseConfig.apiKey) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
    facebookProvider = new FacebookAuthProvider();

    // Add scopes
    googleProvider.addScope('email');
    googleProvider.addScope('profile');
    facebookProvider.addScope('email');
    facebookProvider.addScope('public_profile');
  } catch (error) {
    // Firebase initialization failed - social login will be unavailable
  }
}

/**
 * Initialize Firebase Cloud Messaging
 * @returns {Promise<Messaging|null>}
 */
export const initializeMessaging = async () => {
  if (!app) {
    console.warn('[Firebase] App not initialized');
    return null;
  }

  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn('[Firebase] Messaging not supported in this browser');
      return null;
    }

    const messaging = getMessaging(app);
    console.log('[Firebase] Messaging initialized');
    return messaging;
  } catch (error) {
    console.error('[Firebase] Failed to initialize messaging:', error);
    return null;
  }
};

export { app, auth, googleProvider, facebookProvider };
export const isFirebaseConfigured = !!firebaseConfig.apiKey;
